import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowReference } from "../../../common/controls";
import { ShowMultiLine } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { EsignatureRecipientStatus } from "../../../../api/graphql";
import { ShowString } from "../../../common/controls";
import { ShowDateTime } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type EsignatureRecipientViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  documentValue: { displayId: string; id: string } | null;
  emailValue?: { displayId: string; id: string } | null;
  email: string;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
  roleValue?: { displayId: string; id: string } | null;
  role: string;
  orderValue?: { displayId: string; id: string } | null;
  order: number;
  statusOptions: { id: string; displayId: string }[];
  status: EsignatureRecipientStatus;
  signedAtValue?: { displayId: string; id: string } | null;
  signedAt: Date | null;
};

export const EsignatureRecipientViewForm: React.FC<EsignatureRecipientViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      documentValue,
      email = "",
      name = "",
      role = "",
      order = 0,
      statusOptions = [],
      status = "" as EsignatureRecipientStatus,
      signedAt = null,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupEsignatureRecipientLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowReference
                  label={langStore.EsignatureRecipientDocumentLabel}
                  selectedValue={langStore.displayIdByLang(
                    documentValue?.displayId
                  )}
                />
                <ShowMultiLine
                  value={email}
                  label={langStore.EsignatureRecipientEmailLabel}
                />
                <ShowMultiLine
                  value={name}
                  label={langStore.EsignatureRecipientNameLabel}
                />
                <ShowMultiLine
                  value={role}
                  label={langStore.EsignatureRecipientRoleLabel}
                />
                <ShowNumber
                  value={order}
                  label={langStore.EsignatureRecipientOrderLabel}
                />
                <ShowString
                  value={
                    status
                      ? statusOptions.find(
                          (o: { id: string }) => o.id === status
                        )?.displayId || status
                      : ""
                  }
                  label={langStore.EsignatureRecipientStatusLabel}
                />
                <ShowDateTime
                  value={signedAt}
                  label={langStore.EsignatureRecipientSignedAtLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
